import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { EI18nLanguageUI } from '@packages/utils';
import enTranslate from './texts/en_texts.json';
import esTranslate from './texts/es_texts.json';

const resources = {
  [EI18nLanguageUI.ENGLISH]: {
    translation: enTranslate,
  },
  [EI18nLanguageUI.SPANISH]: {
    translation: esTranslate,
  },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: EI18nLanguageUI.ENGLISH,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
